import React, { Component } from 'react';
import CheckboxTreeContainer from './CheckboxTree/CheckboxTreeContainer';
import { Loading } from './../../Common/Loading';

export default class CheckboxTree extends Component {
  state = {
    selectedGroupIds: [],
    focus: { focusIndex: 0, focusInnerIndex: -1 },
    isAutoExpend: false,
  };

  componentDidMount() {
    this.initDDM();
    this.setFocusToFirstPosition();
  }

  setFocusToFirstPosition() {
    this.setState({ focus: { focusIndex: 0, focusInnerIndex: -1 } });
  }

  componentDidUpdate(prevProps) {
    const { selectedIds, singleSelect, nodes, highlightSearch, isActiveDDMenu } = this.props;

    if (prevProps.showAllSelected !== this.props.showAllSelected && nodes.length) {
      setTimeout(this.showAllSelected, 1);
    }

    if (
      (singleSelect && prevProps.selectedIds !== selectedIds) ||
      (nodes.length && prevProps.nodes.length !== nodes.length)
    ) {
      this.initDDM();
    }

    if (!nodes.length && prevProps.nodes.length) {
      this.hideAll();
    }

    if (!isActiveDDMenu && isActiveDDMenu !== prevProps.isActiveDDMenu) {
      this.setFocusToFirstPosition();
    }

    if (highlightSearch !== prevProps.highlightSearch) {
      const autoExpandOn = 4;
      highlightSearch.length > 1 || nodes.length <= autoExpandOn ? this.showAll() : this.hideAll();
    }
  }

  initDDM() {
    const autoExpandOn = 4;
    if (this.props.nodes.length <= autoExpandOn) {
      this.showAll();
      this.setState({ isAutoExpend: true });
    } else {
      this.setState({ isAutoExpend: false });
      this.showAllSelected();
    }
  }

  showChild = (id) => {
    const { nodes, onSelectLastElement } = this.props;
    const selectedGroupIds = [...this.state.selectedGroupIds, id];
    this.setState({ selectedGroupIds });
    if (nodes[nodes.length - 1].casId === id) {
      onSelectLastElement();
    }
  };

  hideChild = (id) => {
    if (!(this.state.isAutoExpend && this.props.singleSelect)) {
      const selectedGroupIds = this.state.selectedGroupIds.filter((grId) => grId !== id);
      this.setState({ selectedGroupIds });
    }
  };

  showAll = () => {
    if (!this.props.nodes.length) return;
    const selectedGroupIds = this.props.nodes.map((n) => n.casId);
    this.setState({ selectedGroupIds });
  };

  hideAll() {
    this.setState({ selectedGroupIds: [] });
  }

  showAllSelected = () => {
    const { nodes, selectedIds } = this.props;
    if (!selectedIds.length) return;

    const selectedGroupIds = nodes
      .filter((node, parentIndex) => {
        let foundSelected = false;
        node.clients.forEach((c, index) => {
          if (selectedIds.indexOf(c.id) !== -1) {
            foundSelected = true;
          }
        });
        return foundSelected;
      })
      .map((selectedNodes) => selectedNodes.casId);

    this.setState({ selectedGroupIds });
  };

  renderList = () => {
    const {
      classNames = '',
      nodes,
      selectedIds,
      disableTab,
      id,
      ariaLabelledby,
      refWrapper,
    } = this.props;
    const { selectedGroupIds } = this.state;

    return (
    <ul
      role="menubar"
      aria-labelledby={ariaLabelledby}
      id={id}
      ref={refWrapper}
      onKeyDown={(e) => {
        if (disableTab) {
          e.preventDefault();
        }
      }}
      className={`cb-parent-container ${
        this.props.singleSelect && this.state.isAutoExpend ? 'disable-drop-down' : ''
      } ${classNames}`}>
      <CheckboxTreeContainer
        nodes={nodes}
        hideChild={this.hideChild}
        showChild={this.showChild}
        isAutoExpend={this.state.isAutoExpend}
        onSelect={this.props.onSelectCheckbox}
        singleSelect={this.props.singleSelect}
        setHasFocus={this.props.setFocusToSelected}
        selectedIds={selectedIds}
        highlightSearch={this.props.highlightSearch}
        selectedGroupIds={selectedGroupIds}
        focus={this.state.focus}
        closeDDM={this.props.closeDDM}
        closeOnBlurDDM={this.props.closeOnBlurDDM}
        hasContainerFocus={this.props.hasFocus}
        setFocusPosition={(focus) => {
          if (!this.props.singleSelect) return;

          if (!this.props.hasFocus) {
            this.props.setFocusToSelected(true);
          }

          const newFocus = { ...focus };

          if (newFocus.focusIndex < 0) {
            this.props.headerRef.current.focus();
            newFocus.focusIndex = 0;
          }

          this.setState({ focus: newFocus });
        }}
      />
    </ul>);
  }

  render() {
    const {
      errorMsg = '',
      isBusy = false,
    } = this.props;
    return (
      <React.Fragment>
        <Loading show={isBusy} classNames={['checkbox-tree-loading']} />
        { !isBusy ? this.renderList() : void 0 }
        {errorMsg ? (
          <div className="error-msg" role="alert">
            <span className="input-error">{errorMsg}</span>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
